import type {TFunction} from "i18next";
import {enqueueSnackbar, type SnackbarKey} from "notistack";
import type {ServerTableExportFormat} from "./serverTableExport";

/**
 * "Exporting 1,250 rows as Excel…", as `useServerTableExport` says it, for an export a screen builds itself. It
 * stays until the caller closes it with the returned key once the file is saved or the export failed.
 */
export const enqueueServerTableExportStarted = (
    t: TFunction,
    count: number,
    format: ServerTableExportFormat,
): SnackbarKey => enqueueSnackbar(t("Exporting {{count, number}} rows as {{format}}…", {
    count,
    format: format === "xlsx" ? t("Excel") : t("CSV"),
}), {
    variant: "info",
    persist: true,
});

/** "<file> downloaded": the file is saved. */
export const enqueueServerTableExportDone = (t: TFunction, fileName: string) => {
    enqueueSnackbar(t("{{fileName}} downloaded", {fileName}), {variant: "success", autoHideDuration: 3000});
};
